import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IPartyAddressFields {
		id?: any;
		partyId?: any;
		typeId?: any;
		field1?: any;
		field2?: any;
		changedBy?: any;
		datestamp?: any;
		status?: any;
}

export class PartyAddressFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public partyId: IEntityModelField = { name: "partyId", displayName: "Party Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public typeId: IEntityModelField = { name: "typeId", displayName: "Type Id", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public field1: IEntityModelField = { name: "field1", displayName: "Field1", fieldType: FieldType.String, pattern: "NameGeneric" };
	public field2: IEntityModelField = { name: "field2", displayName: "Field2", fieldType: FieldType.String, pattern: "NameGeneric" };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.partyId);
		this.push(this.typeId);
		this.push(this.field1);
		this.push(this.field2);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class PartyAddressDTO implements IEntityModel {
	protected partyAddressName: string = "PartyAddressModel";
	protected partyAddressKeyField: string = "id";
	protected partyAddressDisplayName: string = "Party Address|Party Addresses";
	protected partyAddressFields = new PartyAddressFields();
	public get name(): string { return this.partyAddressName };
	public get keyField(): string { return this.partyAddressKeyField };
	public get displayName(): string { return this.partyAddressDisplayName };
	public get fields(): PartyAddressFields { return this.partyAddressFields };

	constructor() {};
}
